import React from 'react';
import { Scissors, Crown, Award, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Crown,
      title: 'Atendimento Premium',
      description: 'Experiência de alto padrão do início ao fim'
    },
    {
      icon: Scissors,
      title: 'Profissionais Qualificados',
      description: 'Equipe especializada e constantemente atualizada'
    },
    {
      icon: Award,
      title: 'Produtos de Qualidade',
      description: 'Usamos apenas produtos premium e importados'
    },
    {
      icon: Users,
      title: 'Ambiente Exclusivo',
      description: 'Espaço moderno e confortável para sua experiência'
    }
  ];

  return (
    <section id="sobre" className="py-20 bg-transparent">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Sobre a <span className="text-[#D4AF37]">ABR Barbearia</span>
            </h2>
            <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
              <p>
                A ABR Barbearia nasceu com o propósito de entregar mais do que um corte, mas uma <strong className="text-white">experiência completa</strong> de cuidado e transformação masculina.
              </p>
              <p>
                Localizada em Jundiaí Mirim, somos referência em <strong className="text-white">qualidade, profissionalismo e atendimento personalizado</strong>. Cada detalhe foi pensado para proporcionar conforto e satisfação aos nossos clientes.
              </p>
              <p>
                Nossa equipe é formada por profissionais especializados que dominam as mais modernas técnicas de corte, barba e tratamentos capilares, sempre utilizando produtos premium para garantir resultados excepcionais.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-12">
              {features.map((feature) => (
                <div key={feature.title} className="space-y-2">
                  <feature.icon className="h-8 w-8 text-[#D4AF37]" />
                  <h3 className="text-white font-semibold">{feature.title}</h3>
                  <p className="text-gray-400 text-sm">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/6dlkc05l_DSC08041.jpg" 
                  alt="Interior Premium ABR Barbearia"
                  loading="lazy"
                  className="rounded-sm w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                />
                <img 
                  src="https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/39d68vfe_DSC08037.jpg" 
                  alt="Ambiente Moderno ABR"
                  loading="lazy"
                  className="rounded-sm w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="space-y-4 pt-12">
                <img 
                  src="https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/fxn3t2xn_DSC08081.jpg" 
                  alt="Área de Espera Exclusiva ABR"
                  loading="lazy"
                  className="rounded-sm w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
                />
                <img 
                  src="https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/sp6hngiq_carrosel.png" 
                  alt="Fachada ABR Barbearia"
                  loading="lazy"
                  className="rounded-sm w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            </div>
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-[#D4AF37]/10 rounded-sm -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;